import { __extends } from "tslib";
import * as React from 'react';
var LoadingSpinner = /** @class */ (function (_super) {
    __extends(LoadingSpinner, _super);
    /**
     * Class constructor
     * @param {any} props Constructor props
     */
    function LoadingSpinner(props) {
        return _super.call(this, props) || this;
    }
    /**
     * Render component
     * @returns {JSX.Element} Component layout
     * */
    LoadingSpinner.prototype.render = function () {
        return (React.createElement("div", { className: "text-center v-center w-100" },
            React.createElement("div", { className: "spinner" },
                React.createElement("div", { className: "rect1" }),
                React.createElement("div", { className: "rect2" }),
                React.createElement("div", { className: "rect3" }),
                React.createElement("div", { className: "rect4" }),
                React.createElement("div", { className: "rect5" }))));
    };
    return LoadingSpinner;
}(React.PureComponent));
export { LoadingSpinner };
//# sourceMappingURL=LoadingSpinner.js.map